import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import KeyboardVoiceOutlinedIcon from '@mui/icons-material/KeyboardVoiceOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import { Box, Button, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
export const VoiceRecording = ({ voiceRecording, recordingBlob, setRecordingBlob, downloadRecording, updateRecording, fetchExistingRecording, removeRecording, disabled, }) => {
    const { t } = useAlertUiTranslation();
    const getDurationString = () => {
        const duration = voiceRecording.duration;
        if (!duration)
            return '00:00';
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = duration % 60;
        if (hours > 0) {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
        else {
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
    };
    const toggleAudioPlayer = () => {
        if (recordingBlob) {
            setRecordingBlob(null);
        }
        else {
            fetchExistingRecording(voiceRecording);
        }
    };
    return (React.createElement(Box, { sx: { width: '100%', borderRadius: 0.5, border: `1px solid ${themeColors.border.main} `, p: 2 } },
        React.createElement(Typography, { variant: 'subtitle2' }, t(`pages.edit.voice.record.${voiceRecording.type === 'responses' || voiceRecording.type === 'instructions'
            ? voiceRecording.type.slice(0, -1)
            : voiceRecording.type}`) +
            ' ' +
            t('pages.edit.voice.record.recorded')),
        React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between', py: 1.25, alignItems: 'center' } },
            React.createElement(Box, null,
                React.createElement(Button, { "data-testid": 'download-recording-button', color: 'primary', sx: {
                        p: 0,
                        textTransform: 'initial',
                        fontWeight: 'initial',
                    }, onClick: () => downloadRecording(voiceRecording) }, t('pages.edit.voice.record.message') + ' : ' + getDurationString())),
            React.createElement(Box, null,
                updateRecording && (React.createElement(IconButton, { color: 'primary', sx: {
                        ml: 1,
                        p: 0,
                    }, onClick: () => updateRecording && updateRecording(voiceRecording), "data-testid": 'record-button', "aria-label": 'update recording button', disabled: disabled, size: 'large' },
                    React.createElement(KeyboardVoiceOutlinedIcon, { fontSize: 'medium' }))),
                React.createElement(IconButton, { color: 'primary', sx: {
                        ml: 1,
                        p: 0,
                    }, onClick: toggleAudioPlayer, "data-testid": 'play-button', "aria-label": 'play recording button', disabled: disabled, size: 'large' },
                    React.createElement(PlayCircleFilledWhiteOutlinedIcon, { fontSize: 'medium' })),
                removeRecording && (React.createElement(IconButton, { color: 'primary', sx: {
                        ml: 1,
                        p: 0,
                    }, onClick: () => removeRecording && removeRecording(voiceRecording), disabled: disabled, "data-testd": 'remove-button', "aria-label": 'remove recording button', size: 'large' },
                    React.createElement(DeleteOutlinedIcon, { fontSize: 'medium' }))))),
        recordingBlob && (React.createElement("audio", { "data-testid": 'audio-control', preload: 'auto', style: { width: '100%', height: '72px' }, controls: true, controlsList: 'nodownload' },
            React.createElement("source", { src: URL.createObjectURL(recordingBlob), type: 'audio/mpeg' })))));
};
